import Congrats from "../question-sequence/Congrats";
import MedicareMedicaid from "../question-sequence/MedicareMedicaid";
import Income from "../question-sequence/Income";
import CTA from "../question-sequence/Cta";
import DefaultPage from "../pages/default";
import React, { useEffect } from "react";
import { ROUTES } from "./Constant";

const RoutesArray = (cityStateResponse) => {
  const [number, setNumber] = React.useState("");
  const [subsidyAmount, setSubsidyAmount] = React.useState("$6,400");

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const paramSubsidyAmount = urlParams.get("subsidyAmount");
    if (paramSubsidyAmount) {
      setSubsidyAmount(paramSubsidyAmount);
      sessionStorage.setItem("subsidyAmount", paramSubsidyAmount);
    } else {
      setSubsidyAmount(sessionStorage.getItem("subsidyAmount") || "$6,400");
    }
  }, []);
  return [
    {
      path: "/",
      element: (
        <DefaultPage
          cityStateResponse={cityStateResponse}
          setNumber={setNumber}
        />
      ),
      Children: [
        {
          path: "/",
          element: (
            <CTA
              subtitle={
                <h2>
                  New debt reduction plan for Americans, qualifying individuals
                  receive an average debt cancellation of {}
                  <span className="highlighted">$26,352.</span>
                </h2>
              }
              paragraph={`Americans in ${cityStateResponse.city}, ${cityStateResponse.state} with $10,000 or more in credit card debt have a 95% approval rate - financing ends soon.`}
              headline={`2024 Debt Reduction Program`}
            />
          ),
        },
        {
          path: ROUTES.income,
          element: (
            <Income
              headline={`New debt reduction plan for Americans who qualify receive an average debt reduction of $26,352.`}
            />
          ),
        },
        {
          path: ROUTES.medicareMedicaid,
          element: (
            <MedicareMedicaid
              headline={`New debt reduction plan for Americans who qualify receive an average debt reduction of $26,352.`}
            />
          ),
        },
        {
          path: ROUTES.congrats,
          element: (
            <Congrats
              headline={`You could be eligible for ${subsidyAmount} Subsidy.`}
              number={number}
            />
          ),
        },
      ],
    },
    {
      path: "/lander-1",
      element: (
        <DefaultPage
          cityStateResponse={cityStateResponse}
          setNumber={setNumber}
        />
      ),
      Children: [
        {
          path: "/lander-1",
          element: (
            <CTA
              subtitle={`Americans in ${cityStateResponse.state} have only 3 days to claim their FREE ${subsidyAmount}* Subsidy which they can use for Grocery, Rent, Gas and More!`}
              paragraph={`Thanks to a new program, ${cityStateResponse.state} residents could get up to ${subsidyAmount}* allowance for the everyday expense including No-Cost Vision & No-Cost Dental Benefits.`}
              headline={``}
            />
          ),
        },
        {
          path: ROUTES.income,
          element: <Income headline={`Congress Subsidy Program`} />,
        },
        {
          path: ROUTES.medicareMedicaid,
          element: <MedicareMedicaid headline={`Congress Subsidy Program`} />,
        },
        {
          path: ROUTES.congrats,
          element: (
            <Congrats
              headline={`You could be eligible for ${subsidyAmount} Subsidy.`}
              number={number}
            />
          ),
        },
      ],
    },
  ];
};
export default RoutesArray;
